<template>
  <div ref="containerRef" class="faq-container">
    <div class="cabinet_container_alert" v-if="text">
      <BaseIcon icon="alert-quest-icon" />
      <div class="text-base-h6">
        <template v-if="question">
          {{ $t("frequently_questions") }}:
          <a
            href="#"
            class="text-base-span-md"
            @click.prevent="toggleText"
          >{{ question }}</a>
        </template>
        <template v-else>
          <a
            href="#"
            class="text-base-span-md"
            @click.prevent="toggleText"
          >{{ $t("frequently_questions") }}</a>
        </template>
      </div>
    </div>
    <div v-if="text" class="custom-margin">
      <Collapsible :isOpen="showMainText">
        <div
          :id="id"
          class="text-justify faq-text mx-auto max-w-7xl w-full sm:px-6 lg:px-8 z-10 px-3 py-2 text-sm font-medium text-gray-900 bg-white border  rounded-lg shadow-sm"
        >
          {{ text }}
        </div>
      </Collapsible>
    </div>
  </div>
</template>

<script>
import { initTooltips } from "flowbite";
import Collapsible from "~/components/Common/Collapsible.vue";

export default {
  name: "QuestionAlert",
  components: {
    Collapsible
  },
  props: {
    question: String,
    id: String,
    text: String
  },
  data() {
    return {
      showMainText: false
    };
  },
  mounted() {
    initTooltips();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleText() {
      this.showMainText = !this.showMainText;
    },
    handleClickOutside(event) {
      if (this.$refs.containerRef && !this.$refs.containerRef.contains(event.target)) {
        this.showMainText = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom {
  transform: translateY(-33%);
  top: 50%;
  left: 0%;
  inset: auto !important;
}

.custom-margin {
  margin-top: 20px !important;
}

.faq-text {
  white-space: pre-line;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
